<div class="form-modal">
    <h1 mat-dialog-title>{{'CONFIRM_RESPONSE' | translate}}: {{documentNumber}}</h1>
    <div mat-dialog-content>
      <form [formGroup]="form" class="form-horizontal">
        <div class="form-group">
          <div class="col-md-12 col-sm-12 spacer-bottom-xs"></div>
          <div class="table-responsive col-lg-12 col-md-12 col-sm-12 no-padding">
            <div *ngIf="details.length > 0">
              <div *ngIf="formErrorsDetails.length>0" class="validation-summary-errors text-danger col-md-6">
                <ul>
                  <li *ngFor="let errorMessage of formErrorsDetails; let i = index" [translate] [translateParams]="formErrorsDetailsParam[i]">{{errorMessage}}</li>
                </ul>
              </div>
              <table class="reception-table table-bordered" id="reception-table" formArrayName="DetailsList"
                cdkFocusInitial>
                <thead>
                  <tr>
                    <th width="4%" class="text-center">
                      <strong>#</strong>
                    </th>
                    <th width="8%">
                      <strong>{{'CODE_SANITOP'|translate}}</strong>
                    </th>
                    <th width="10%">
                      <strong>{{'SUPPLIER_REFERENCE'|translate}}</strong>
                    </th>
                    <th width="10%">
                      <strong>{{'ORDERED_QUANTITY'|translate}}</strong>
                    </th>
                    <th width="10%">
                      <strong>{{'UNIT_DATATABLE_HEAD'|translate}}</strong>
                    </th>
                    <th width="10%">
                      <strong>{{'REVISED_QUANTITY'|translate}}</strong>
                    </th>
                    <th width="15%">
                      <strong>{{'DELIVERY_DATE'|translate}}</strong>
                    </th>
                    <th width="15%">
                      <strong>{{'SUPPLIER_DELIVERY_DATE'|translate}}</strong>
                    </th>
                    <th width="7%">
                      <strong>{{'UNIT_PRICE_DATATABLE_HEAD'|translate}}</strong>
                    </th>
                    <th width="7%">
                      <strong>{{'SUPPLIER_UNIT_PRICE_DATATABLE_HEAD'|translate}}</strong>
                    </th>

                    <!-- Botões -->
                    <th></th>
                  </tr>
                </thead>
                <tbody *ngFor="let item of form.controls.DetailsList.controls; let i=index" [formGroupName]="i">
                  <tr>
                    <td>
                      <mat-form-field class="allwidth">
                        <input matInput formControlName="LineNumber" class="no-padding-left">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="allwidth">
                        <input matInput formControlName="Code" class="no-padding-left">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="allwidth">
                        <input matInput formControlName="SupplierProductCode" class="no-padding-left">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="allwidth">
                        <input matInput formControlName="OrderedQuantity" class="no-padding-left">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="allwidth">
                        <input matInput formControlName="OrderedQuantityUOMCode" class="no-padding-left">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="allwidth">
                        <input matInput formControlName="RevisedQuantity" class="no-padding-left">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="allwidth">
                        <mat-label>{{ 'EARLIEST_ACCEPTABLE_DATE' | translate}}</mat-label>
                        <input matInput
                                    formControlName="DeliveryEarliestAcceptableDate" class="one date-picker" [tipoDateTime]="1">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="allwidth">
                        <input matInput
                          formControlName="SupplierDeliveryDate" class="one date-picker" [tipoDateTime]="1">
                            <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="allwidth">
                        <input matInput formControlName="NetUnitPrice" class="no-padding-left">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="allwidth">
                        <input matInput formControlName="SupplierNetUnitPrice" class="no-padding-left">
                      </mat-form-field>
                    </td>

                    <!-- Botões -->
                    <td>  
                      <!--start: Re-Cotar Resposta-->
                      <button type="button" class="btn btn-sm" (click)="rejectDetail(i)"
                        *ngIf="item.get('RevisedQuantity').value != 0 || item.get('SupplierNetUnitPrice').value != 0 ">
                        <span title="{{'BUTTON.REJECT' | translate}}">
                          <i class="fas fa-times-circle color-danger backwhite"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div mat-dialog-actions>
      <div class="full-width text-right">
        <button type="button" class="btn btn-default" (click)="resetForm();dialogRef.close(null)">
          <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
        </button>
        <button type="button" class="btn btn-primary" (click)="save()">
          <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
        </button>
        <button type="button" class="btn btn-primary" (click)="save(true)">
          <i class="fas fa-reply"></i>&nbsp;{{'BUTTON.ANSWER' | translate}}
        </button>
      </div>
    </div>
  </div>